const constants = {
  omitNationality: ["RUS", "BLR"]
};
export default constants;
